import {Component, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {ReportsState} from '../../../shared/states/reports/reports.state';
import {Observable} from 'rxjs/internal/Observable';
import {GetDeaRecords, SaveNewReportData, SetDeaRecordsList} from '../../../shared/states/reports/reports.actions';
import {BaseTableDirective} from '../../../shared/directives/base-table.directive';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IDeaRecord} from '../../../shared/interfaces/dea-record.interface';
import {Router} from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-dea-reports',
  templateUrl: './dea-reports.component.html',
  styleUrls: ['./dea-reports.component.scss'],
})
export class DeaReportsComponent extends BaseTableDirective implements OnInit {
  showNewReportDialog: boolean;
  deaRecordsList: IDeaRecord[] = [];

  tableColumns = {
    createdDate: false,
    name: true,
    firstName: true,
    recordCount: true,
  };

  @Select(ReportsState.loading) isLoading$: Observable<boolean | undefined>;
  @Select(ReportsState.deaRecords) deaRecords$: Observable<IDeaRecord[]>;

  constructor(
    protected store: Store,
    private router: Router,
  ) {
    super(store);
  }

  ngOnInit(): void {
    this.store.dispatch(new GetDeaRecords());

    this.deaRecords$.pipe(untilDestroyed(this))
      .subscribe((data: IDeaRecord[]) => {
        this.deaRecordsList = data;
      });
  }

  newReport(): void {
    this.showNewReportDialog = true;
  }

  viewReport(id: string): void {
    this.router.navigateByUrl(`/reports/dea-compliance/details/${id}`);
  }

  sortByColumn(columnName: string): void {
    this.store.dispatch(new SetDeaRecordsList(this.sort(this.deaRecordsList, columnName)));
  }

  runReport(data: any): void {
    this.store.dispatch(new SaveNewReportData(data));
    this.router.navigateByUrl(`/reports/dea-compliance/details/${data.id}`);
  }
}
